export class RPC_Error extends Error ::
  get is_rpc() :: return true

  constructor(msg, rpc) ::
    super(msg)
    if rpc ::
      this.rpc = rpc

  static from({err, rpc, ...kw}) ::
    let self = new this(err, rpc)
    return Object.assign(self, kw)

